import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getScore } from '../api/repositories/score/score.sagas';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import {
  EScoreActionType,
  getScoreSuccessAction,
  IGetScoreAction,
} from './actions';

export function* getScoreSaga(action: IGetScoreAction) {
  if (!(yield* checkHasCompletedProfile())) return;

  const response = yield call(getScore, action.payload);

  yield put(getScoreSuccessAction(response));
}

export function* scoresRootSaga() {
  yield all([
    takeLatest(
      EScoreActionType.GET,
      handleAsyncStatus(getScoreSaga, EAsyncEventTypes.GET_SCORE)
    ),
  ]);
}
